<app-selfdrive-home *ngIf="selfDrive === url"></app-selfdrive-home>

<app-pick-drop *ngIf="pickDrop === url"></app-pick-drop>

<app-home *ngIf="carRental === url"></app-home>